<script>
import wootConstants from 'dashboard/constants/globals';

export default {
  props: {
    status: {
      type: String,
      default: wootConstants.STATUS_TYPE.PENDING,
    },
  },
  computed: {
    bannerMessage() {
      const messages = {
        [wootConstants.STATUS_TYPE.SNOOZED]:
          'Replies to users are not allowed while the conversation is On Hold. Please reopen the conversation before responding.',
        [wootConstants.STATUS_TYPE.PENDING]:
          'AI is currently processing this inquiry. Please wait until the conversation is assigned to an agent.',
      };
      return (
        messages[this.status] ||
        'AI is currently processing this inquiry. Please wait until the conversation is assigned to an agent.'
      );
    },
  },
};
</script>

<template>
  <div
    class="flex items-center justify-center h-12 gap-4 px-4 py-3 text-xs banner dark:text-white ai-attention-banner attention"
  >
    <span class="banner-message flex items-center">
      <img src="~dashboard/assets/images/attention.svg" alt="" class="inline-block mr-4 h-4 w-4" />
      {{ bannerMessage }}
    </span>
  </div>
</template>

<style lang="scss" scoped>
.ai-attention-banner {
  &.attention {
    @apply bg-[#ECF0F8] text-[#1758B4] font-bold rounded-lg;
  }

  .banner-message {
    @apply flex items-center;
  }
}
</style>
